import { Flex, Space, Spacing, Text } from '@billy/design-system'
import { useBooleanFlagDetails, useOpenFeatureClientStatus } from '@openfeature/react-sdk'

import { EXPENSES_TEST_FLAG } from '@features/remoteFeatureFlags/constants'
import {
  getRemoteFeatureFlagProviderError,
  isRemoteFeatureFlagsReady,
} from '@features/remoteFeatureFlags/initRemoteFeatureFlags'
import { useRemoteFeatureFlag } from '@features/remoteFeatureFlags/useRemoteFeatureFlag'
import { useUserOrganization } from '@modules-deprecated/app/organization'

export const RemoteFeatureFlags = () => {
  const { organization } = useUserOrganization()
  const flagValue = useRemoteFeatureFlag(EXPENSES_TEST_FLAG)
  const flagDetails = useBooleanFlagDetails(EXPENSES_TEST_FLAG, false)
  const providerStatus = useOpenFeatureClientStatus()
  const datadogConfig = window.ENV?.datadogConfig

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <Space size="s2" />
      <Text variant="h3">Smoke flag</Text>
      <div>
        <strong>Key:</strong> {EXPENSES_TEST_FLAG}
      </div>
      <div>
        <strong>Value:</strong> {String(flagValue)}
      </div>
      <div>
        <strong>Reason:</strong> {flagDetails.reason ?? '—'}
      </div>
      <div>
        <strong>Variant:</strong> {flagDetails.variant ?? '—'}
      </div>
      <div>
        <strong>Error code:</strong> {flagDetails.errorCode ?? '—'}
      </div>
      <div>
        <strong>Error message:</strong> {flagDetails.errorMessage ?? '—'}
      </div>
      <div>
        <strong>Provider status:</strong> {providerStatus}
      </div>
      <div>
        <strong>Provider registered:</strong> {isRemoteFeatureFlagsReady() ? 'yes' : 'no'}
      </div>
      <div>
        <strong>Provider init error:</strong> {getRemoteFeatureFlagProviderError() ?? '—'}
      </div>

      <Text variant="h3">Evaluation context</Text>
      <div>
        <strong>organizationId (targetingKey):</strong> {organization?.id ?? '—'}
      </div>

      <Text variant="h3">Datadog config</Text>
      <div>
        <strong>env:</strong> {datadogConfig?.env ?? '—'}{' '}
        <Text variant="bodySM">
          (development / staging / production — must match Datadog Feature Flags, same as e-invoicing DD_ENV)
        </Text>
      </div>
      <div>
        <strong>service:</strong> {datadogConfig?.service ?? '—'}
      </div>
      <div>
        <strong>site:</strong> {datadogConfig?.site ?? '—'}
      </div>
      <div>
        <strong>theme:</strong> {window.ENV?.theme ?? '—'}
      </div>
      <div>
        <strong>applicationId:</strong> {datadogConfig?.applicationId ? 'set' : 'missing'}
      </div>
      <div>
        <strong>clientToken:</strong> {datadogConfig?.clientToken ? 'set' : 'missing'}
      </div>
    </Flex>
  )
}
